/**
 * @TODO 并不是 polyfill，尽量用 url-search-params 的 polyfill 代替
 */

import QS from "qs";

const ArraySep = "~";

function shortenArray(obj) {
  return Object.keys(obj)
    .map(key => {
      let value = obj[key];
      if (Array.isArray(value)) {
        value = [value.filter(Boolean).join(ArraySep)];
        if (!value[0]) value = undefined;
      }
      return [key, value];
    })
    .reduce((res, [key, value]) => {
      res[key] = value;
      return res;
    }, {});
}

function expandArray(obj) {
  return Object.keys(obj)
    .map(key => {
      const value = obj[key];
      return [
        key,
        Array.isArray(value)
          ? value.reduce((arr, item) => arr.concat(item.split(ArraySep)), []).filter(Boolean)
          : value,
      ];
    })
    .reduce((res, [key, value]) => {
      res[key] = value;
      return res;
    }, {});
}

/**
 * search 字符串转 query 对象
 * @param {String} queryStr
 * @param {Object} [opts={}]
 * @returns {Object}
 */
export function urlQueryParams(queryStr, opts = {}) {
  const { stringArray, ...qsOpts } = opts;
  const r = QS.parse(queryStr, { ignoreQueryPrefix: true, ...qsOpts });
  return stringArray ? expandArray(r) : r;
}

/**
 * query 对象转 search 字符串(包含前置问号)
 * @param {Object} obj
 * @param {Object} [opts={}]
 * @returns {String}
 */
export function urlSearchParams(obj, opts = {}) {
  const { stringArray, ...qsOpts } = opts;
  return QS.stringify(stringArray ? shortenArray(obj) : obj, {
    skipNulls: true,
    addQueryPrefix: true,
    arrayFormat: "brackets",
    ...qsOpts,
  });
}

/**
 * 移除 search 前置的问号
 * @param {String} search
 * @returns {string}
 */
export function trimSearch(search) {
  return (search || "").replace(/^\?/, "");
}
